// extracted by mini-css-extract-plugin
module.exports = {"ImageAndText":"BiddingProcessSection-module__ImageAndText___zUWwO","image":"BiddingProcessSection-module__image___pC8vm","text":"BiddingProcessSection-module__text___RKDWP"};